<script setup>
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStoreGetters, useStore } from 'dashboard/composables/store';

import SettingIntroBanner from 'components/widgets/SettingIntroBanner.vue';
import Spinner from 'next/spinner/Spinner.vue';
import BasicSettings from './BasicSettings.vue';
import AttributesSettings from './AttributesSettings.vue';

const route = useRoute();
const store = useStore();
const getters = useStoreGetters();

const uiFlags = getters['wgptSamlProviders/getUIFlags'];
const getSamlProvider = getters['wgptSamlProviders/getSamlProvider'];
const samlProviderId = computed(() => Number(route.params.samlProviderId));
const samlProvider = computed(() => {
  return getSamlProvider.value(samlProviderId.value);
});
const isLoading = computed(() => {
  if (!samlProvider.value) return true;
  return uiFlags.isFetchingItem;
});

const fetchSamlProvider = () => {
  if (samlProvider.value) return;
  store.dispatch('wgptSamlProviders/show', samlProviderId.value);
};

onMounted(() => {
  fetchSamlProvider();
});
</script>

<template>
  <div
    class="flex-grow flex-shrink w-full min-w-0 pl-0 pr-0 settings flex flex-col overflow-hidden"
  >
    <SettingIntroBanner :header-title="samlProvider.display_name" />

    <section class="w-full flex-1 flex flex-col overflow-hidden">
      <div
        v-if="isLoading"
        class="flex items-center justify-center py-10 text-n-slate-11"
      >
        <Spinner />
      </div>
      <div v-else class="flex-1 overflow-hidden">
        <div class="h-full overflow-auto">
          <BasicSettings :saml-provider="samlProvider" />
          <AttributesSettings :saml-provider="samlProvider" />
        </div>
      </div>
    </section>
  </div>
</template>
